<template lang="pug">
b-dropdown(
  :value="key"
  @change="change"
)
  a.button(slot="trigger")
    b-icon(:icon="type.icon")
    span {{ type.label }}
  b-dropdown-item(
    v-for="t in types"
    :key="t.key"
    :value="t.key"
  )
    article.media
      figure.media-left
        b-icon(:icon="t.icon")
      .media-content
        b {{ t.label }}
        br
        small.has-text-grey {{ t.description }}
</template>

<script>
import _ from 'lodash';

export default {
  name: 'form-block-type-select',
  created() {
    this.key = this.value;
    this.type = _.find(this.types, { key: this.value });
  },
  data() {
    return {
      key: null,
      type: {},
      types: [
        {
          description: 'Add any number of custom fields',
          key: 'custom',
          icon: 'settings',
          label: 'Custom',
        },
        {
          description: 'Collect information from one or more people',
          key: 'participant',
          icon: 'account-multiple',
          label: 'Participant',
        },
        {
          description: 'Credit card fields (required if this is a paid event)',
          key: 'payment',
          icon: 'credit-card',
          label: 'Payment',
        },
      ],
    };
  },
  methods: {
    change(val) {
      this.$emit('input', val);
      this.type = _.find(this.types, { key: val });
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/FormBlockTypeSelect.vue